export default __webpack_public_path__ + "static/media/walkingIcon.ed858eb6.svg";